var $ = require('jQuery');
var Component = require('../../Component');
var template = require('../../../template/float-view.html');
var utils = require('../../../global/utils');
var isEmpty = utils.isEmpty;
var MsgViewer = require('../../msg/MsgViewer');
var timeLabel = '<div class="im-float-view-time"><div class="im-float-label-time">${time}</div></div>';

var FloatView = function (options) {
    (function (self) {
        var defaults = {
            template: template,
            stage: 1
        };
        $.extend(defaults, options);
        Component.call(self, defaults);
    })(this);

    (function (self) {
      var msgViewer = new MsgViewer({
        in_float_view: true
      });
      self._children['msgViewer'] = msgViewer;
      self._element.find('.im-float-view-body').append(msgViewer.getElement());
      self._children_views = {};
    })(this);
};

FloatView.prototype = Object.create(Component.prototype);

FloatView.prototype.render = function () {
  var title = this._data.title;
  var self = this;
  var element = this.getElement();
  var _messages = [];
  var _msg_id = 1;
  element.find('.im-float-view-title .im-float-records').html(title);
  element.on('click', function(e){
    self.triggerEvent('setTop', {
      u_key: self._options._u_key
    });
  });
  element.find('.im-float-close').on('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    self.triggerEvent('close', {
      u_key: self._options._u_key
    });
  });
  (self._data.msgList || []).forEach(function(msg, index){
    if (typeof msg.content === 'string') {
      msg.content = JSON.parse(msg.content);
    }
    msg.show_type = msg.content.type;
    switch (msg.content.type) {
      case 'audio':
        msg.content.msg = '[语音留言]';
        msg.content.type = 'text';
        msg.show_type = 'text';
        break;
      case 'video':
        break;
      case 'text':
        break;
      case 'card':
      case 'minicard':
      case 'universal_card1':
      case 'universal_card2':
      case 'universal_card3':
      case 'mix':
      case 'universal_card4':
      case 'universal_card5':
      case 'universal_card6':
      case 'private_card_ganji':
        break;
      case 'file':
        break;
      case 'location':
        msg.content.msg = '消息格式暂不支持，请在客户端查看';
        msg.content.type = 'text';
        msg.show_type = 'text';
        break;
      case 'call_audio':
        msg.content.msg = '[收到一条语音聊天消息，请在手机上查看]';
        msg.content.type = 'text';
        msg.show_type = 'text';
        break;
      case 'call_video':
        msg.content.msg = '[收到一条视频聊天消息，请在手机上查看]';
        msg.content.type = 'text';
        msg.show_type = 'text';
        break;
      case 'image':
        break;
      case 'provide_contactinfo_card':
      case 'default_contactinfo_card':
        break;
      case 'msg_batch_forward_card':
        msg.content._parent_u_key = self._options._u_key;
        msg.content._root_u_key = self._options._root_u_key;
        msg.show_type = 'msg_batch_forward_card';
        break;
      default:
        msg.content.msg = '消息格式暂不支持，请在客户端查看';
        msg.content.type = 'text';
        msg.show_type = 'text';
        break;
    }
    _messages.push({
      msg_id: msg.msg_id,
      _msg_id: Number('' + (new Date()).valueOf() + _msg_id++),
      sender_id: msg.sender_id,
      sender_source: msg.sender_source,                  
      to_id: msg.to_id,                             
      to_source: msg.to_source,
      content: msg.content,
      sender_info: {
        avatar: msg.sender_avatar,
        user_name: msg.sender_name,
        hide_avatar: index > 0 ? msg.isSameUserWithPrevious : false
      },
      is_in_float_view: true,
      u_key: self._options._u_key,
      send_time: msg.create_time,
      show_type: msg.show_type,
      msg_collect: msg.msg_collect ? msg.msg_collect :null,
      forward_msgs: msg.forward_msgs?msg.forward_msgs:null,
      msg_type: 1005,
      tel: msg.tel ? msg.tel:null,
      wechat: msg.wechat ? msg.wechat:null,
      is_uptodate:msg.is_uptodate

      
    });
  });
  _messages.sort(function(fr, af){
    return fr.send_time > af.send_time ? 1 : -1;
  });
  self._children['msgViewer'].addMsg(_messages);
  if (_messages.length) {
    var frTime = new Date(Number(_messages[0].send_time));
    var afTime = new Date(Number(_messages[_messages.length - 1].send_time));
    if(frTime === afTime){
      element.find('.im-msg-list').prepend(timeLabel.replace('${time}', [frTime.getFullYear(), frTime.getMonth() + 1,frTime.getDate()].join('/')));
    }else{
      element.find('.im-msg-list').prepend(timeLabel.replace('${time}', [frTime.getFullYear(), frTime.getMonth() + 1,frTime.getDate()].join('/') + '-' + [afTime.getFullYear(), afTime.getMonth() + 1,afTime.getDate()].join('/')));
    }
  }
};
FloatView.prototype.show = function (text) {
    Component.prototype.show.call(this);
};
FloatView.prototype.hide = function () {
    Component.prototype.hide.call(this);
};

module.exports = FloatView;
